<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px"
        v-loading="loading">

        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="plateNumber" label="车牌号">
            <!-- <el-input v-model="formData.plateNumber" placeholder="请输入车牌号"></el-input> -->
            <el-select v-model="formData.plateNumber" clearable @change="changePlate" filterable placeholder="请选择车牌号">
            <el-option v-for="(item, index) of vehicleList" :value="item.plateNumber" :label="item.plateNumber"
              :key="index"></el-option>
          </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driver" label="司机姓名">
            <el-input v-model="formData.driver" disabled placeholder="根据车牌号自动带出"></el-input>

          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverPhone" label="司机手机">
            <el-input v-model="formData.driverPhone" disabled placeholder="根据车牌号自动带出"></el-input>

          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="outTime" label="外出时间">
            <el-date-picker v-model="formData.outTime" placeholder="请选择外出时间" type="datetime" clearable
              format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="returnTime" label="回厂时间">
            <el-date-picker v-model="formData.returnTime" placeholder="请选择回厂时间" type="datetime" clearable
              format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="reason" label="外出原因">
            <el-input type="textarea" v-model="formData.reason" placeholder="请输入外出原因"></el-input>

          </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <div class="row-wrap">

                <div class="images-wrap" v-for="(item, index) of $attachmentFiles(formData.fileList)" :key="index">
                  <i class="el-icon-error close-icon" @click="delImage(formData.fileList.indexOf(item))"></i>
                  <el-image style="width: 100%; height: 100%" :src="item.filePrefix + item.fileUrl"
                    :preview-src-list="fileImgUrl" fit="cover" />
                </div>

                <el-upload class="upload-demo" :show-file-list="false" :action="$apis.common.uploadUrl"
                  :on-success="handleSuccess" :before-upload="beforeUpload" list-type="picture-card">
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">
                    图片大小不能超过10MB~
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>
// import { validateLicensePlate } from '@/utils/validator.js'

export default {
  name: 'vehicleAccessAdd',

  data () {
    return {
      formData: {
        outTime: '',
        returnTime: '',
        plateNumber: '',
        driver: '',
        driverPhone: '',
        reason: '',
        fileList: []
      },

      rules: {

        outTime: [
          {
            required: true,
            message: '请选择外出时间',
            trigger: ['blur', 'change']
          }
        ],
        returnTime: [
          {
            required: true,
            message: '请选择回厂时间',
            trigger: ['blur', 'change']
          }
        ],
        plateNumber: [
          {
            required: true,
            message: '请输入车牌号',
            trigger: ['blur', 'change']
          }
          // {
          //   validator: (rule, value, callback) => validateLicensePlate(rule, value, callback)

          // }
        ],
        // driver: [
        //   {
        //     required: true,
        //     message: '请输入司机姓名',
        //     trigger: ['blur', 'change']
        //   }
        // ],
        // driverPhone: [
        //   {
        //     required: true,
        //     message: '请输入司机手机',
        //     trigger: ['blur', 'change']
        //   },
        //   { pattern: validPhoneNumber, message: '手机号格式错误' }

        // ],
        reason: [
          {
            required: true,
            message: '请选择外出原因',
            trigger: ['blur', 'change']
          }
        ]

      },
      loading: false,
      vehicleList: []

    }
  },
  created () {
    this.loadDataVehicle()
    if (this.recordId) {
      this.loadData()
    }
  },
  computed: {
    recordId () {
      return this.$route.query.recordId
    },
    fileImgUrl () {
      const arr = this.$attachmentFiles(this.formData.fileList).map(item => {
        return item.filePrefix + item.fileUrl
      })
      return arr
    }

  },
  methods: {
    changePlate(val) {
      if (val) {
        const info = this.vehicleList.find(item => item.plateNumber === val)
        if (info) {
          this.formData.driver = info.driver || ''
          this.formData.driverPhone = info.driverPhone || ''
        }
      } else {
        this.formData.driver = ''
        this.formData.driverPhone = ''
      }
    },
    loadDataVehicle() {
      this.$axios
        .get(this.$apis.vehicleManage.selectPaVehicleInfoByPage, {
        })
        .then(res => {
          this.vehicleList = res.list
        })
    },
    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.vehicleAccess.selectPaVehicleOutByRecordId, {
          params: { recordId: this.recordId }
        })
        .then(res => {
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleSuccess (res) {
      this.formData.fileList.push(res.data)
    },

    delImage (index) {
      this.formData.fileList.splice(index, 1)
    },
    beforeUpload (file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
      }
      return isImage && isLt10M
    },

    submit () {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          let url = this.$apis.vehicleAccess.insertPaVehicleOut
          if (this.recordId) {
            url = this.$apis.vehicleAccess.updatePaVehicleOut
          }

          this.$axios.post(url, { ...this.formData }).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
